import BrandList from "../../slices/inventory/brand/BrandList";
import BrandDetails from "../../slices/inventory/brand/BrandDetails";
import ItemList from "../../slices/inventory/item/ItemList";
import ItemDetails from "../../slices/inventory/item/ItemDetails";
import MeasureUnitTypeList from "../../slices/inventory/measure_unit_type/MeasureUnitTypeList";
import MeasureUnitTypeDetails from "../../slices/inventory/measure_unit_type/MeasureUnitTypeDetails";
import MeasureUnitList from "../../slices/inventory/measure_unit/MeasureUnitList";
import MeasureUnitDetails from "../../slices/inventory/measure_unit/MeasureUnitDetails";
import SubCategoryList from "../../slices/inventory/sub_category/SubCategoryList";
import SubCategoryDetails from "../../slices/inventory/sub_category/SubCategoryDetails";
import SubCatbyCat from "../../slices/inventory/sub_category/SubCatbyCat";
import ProductPricingFilter from "../../slices/inventory/product_pricing/ProductPricingFilter";
import ProductPricingList from "../../slices/inventory/product_pricing/ProductPricingList";
import CustomerPricingList from "../../slices/inventory/customer_pricing/CustomerPricingList";
import CustomerPricingFilter from "../../slices/inventory/customer_pricing/CustomerPricingFilter";
import CustomerCategoryPricingList from "../../slices/inventory/customer_category_pricing/CustomerCategoryPricingList";
import CustomerCategoryPricingFilter from "../../slices/inventory/customer_category_pricing/CustomerCategoryPricingFilter";
import ColorList from "../../slices/inventory/color/ColorList";
import ColorDetails from "../../slices/inventory/color/ColorDetails";
import SegmentList from "../../slices/inventory/segment/SegmentList";
import SegmentDetails from "../../slices/inventory/segment/SegmentDetails";
import RackList from "../../slices/inventory/rack/RackList";
import RackDetails from "../../slices/inventory/rack/RackDetails";
import DeliveryNoteList from "../../slices/inventory/delivery_note/DeliveryNoteList";
import DeliveryNoteDetails from "../../slices/inventory/delivery_note/DeliveryNoteDetails";
import PaymentList from "../../slices/inventory/payment/PaymentList";
import DeliveryNoteListByCustomer from "../../slices/inventory/invoice/DeliveryNoteListByCustomer";
import DeliveryNoteItemList from "../../slices/inventory/invoice/DeliveryNoteItemList";
import InvoiceList from "../../slices/inventory/invoice/InvoiceList";
import InvoiceDetails from "../../slices/inventory/invoice/InvoiceDetails";
import DispatchAdviceByPlanningList from "../../slices/inventory/delivery_note/DispatchAdviceByPlanningList";

const inventoryReducer = {
    brandList: BrandList,
    brandDetails: BrandDetails,
    itemList: ItemList,
    itemDetails: ItemDetails,
    measureUnitTypeList: MeasureUnitTypeList,
    measureUnitTypeDetails: MeasureUnitTypeDetails,
    measureUnitList: MeasureUnitList,
    measureUnitDetails: MeasureUnitDetails,
    subCategoryList: SubCategoryList,
    subCategoryDetails: SubCategoryDetails,
    subCatbyCat: SubCatbyCat,
    productPricingList: ProductPricingList,
    productPricingFilter: ProductPricingFilter,
    customerPricingList: CustomerPricingList,
    customerPricingFilter: CustomerPricingFilter,
    customerCategoryPricingList: CustomerCategoryPricingList,
    customerCategoryPricingFilter: CustomerCategoryPricingFilter,
    colorList: ColorList,
    colorDetails: ColorDetails,
    segmentList: SegmentList,
    segmentDetails: SegmentDetails,
    rackList: RackList,
    rackDetails: RackDetails,
    deliveryNoteList: DeliveryNoteList,
    deliveryNoteDetails: DeliveryNoteDetails,
    paymentList: PaymentList,
    deliveryNoteListByCustomer: DeliveryNoteListByCustomer,
    deliveryNoteItemList: DeliveryNoteItemList,
    invoiceList: InvoiceList,
    invoiceDetails: InvoiceDetails,
    dispatchAdviceByPlanningList: DispatchAdviceByPlanningList,
};

export default inventoryReducer;